import React, { useEffect, useState, useContext } from 'react';
import api from '../api/client';
import { AuthContext } from '../context/AuthContext';
import './AuditLogs.css';

const AuditLogs = () => {
  const { access } = useContext(AuthContext);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await api.get(`/api/audit/my/`);
        setLogs(res.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load audit logs');
        setLoading(false);
      }
    };
    fetchLogs();
  }, [access]);

  return (
    <div className="container">
      <div className="card">
        <h2 className="title">Audit Logs</h2>
        {loading ? (
          <p className="loading">Loading...</p>
        ) : error ? (
          <div className="error">{error}</div>
        ) : logs.length === 0 ? (
          <p className="noData">No audit logs found.</p>
        ) : (
          <table className="table">
            <thead>
              <tr className="tableHead">
                <th className="tableHeader">Date</th>
                <th className="tableHeader">Action</th>
                <th className="tableHeader">Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id} className="tableRow">
                  <td className="tableCell">{log.timestamp}</td>
                  <td className="tableCell">{log.action}</td>
                  <td className="tableCell">{log.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AuditLogs;
